<template>
  <div>
    <el-dialog
      :title="`模板“${name}”——添加使用${typeName}`"
      :visible.sync="visible"
      width="510px"
      custom-class="my-dialog-template"
      :close-on-click-modal="false"
    >
      <el-form :inline="true" :model="formData" ref="formRef" class="my-form-template" label-width="120px" v-loading="loading">
        <el-form-item :label="`选择${typeName}`" prop="mechanIds" class="full" :rules="$tools.formRule.arrRequired('请选择使用' + typeName)">
          <el-checkbox v-model="isAll" @change="selectAll">全部{{ typeName }}</el-checkbox>
          <el-select v-model="formData.mechanIds" placeholder="请选择" multiple collapse-tags @change="selectChange">
            <el-option v-for="(bean, i) in orgList" :key="i" :label="bean.shortName || bean.name" :value="bean.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="warning" plain @click="visible = false">取消</el-button>
        <el-button type="warning" class="bgBtn" @click="save()">保存</el-button>
      </div>
    </el-dialog>
    <modalLoading ref="modalLoading" class="modal-loading"></modalLoading>
  </div>
</template>
<script>
import modalLoading from "@/components/modalLoading";
export default {
  data: () => ({
    visible: false,
    loading: false,
    isAll: false,
    name: "",
    type: '',
    mechanId: '',
    formData: {
      mechanIds: []
    },
    orgList: [],
  }),
  computed: {
    typeName() {
      return this.type == '1' ? '团队' : '业务员'
    }
  },
  components: { modalLoading },
  methods: {
    open(data = {}) {
      console.log(data)
      this.type = data.type;
      this.name = data.name;
      this.mechanId = data.mechanId;
      this.formData = {
        commissonTemplateCode: data.code,
        mechanIds: []
      }
      this.visible = true;
      this.isAll = false;
      this.$refs.formRef && this.$refs.formRef.clearValidate()
      if (data.type == '1') {
        this.getOrgList();
      } else {
        this.getUserList();
      }
    },
    selectChange() {
      if (this.orgList.length == this.formData.mechanIds.length) {
        this.isAll = true;
      } else {
        this.isAll = false;
      }
    },
    // 选择所有团队
    selectAll() {
      if (this.isAll) {
        const list = this.orgList.map((item) => {
          return item.id;
        })
        this.$set(this.formData, "mechanIds", list);
      } else {
        this.$set(this.formData, "mechanIds", []);
      }
    },
    getUserList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {
          mechanId: this.mechanId,
          filterCommissonTemplateCode: this.formData.commissonTemplateCode,
        },
      }).then(res => {
        this.orgList = res.data
      })
    },
    getOrgList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          filterCommissonTemplateCode: this.formData.commissonTemplateCode,
          parentId: this.mechanId,
          useStatus: 1,
        },
      }).then(res => {
        this.orgList = res.data
      })
    },
    save() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.$refs.modalLoading.open({
            title: "正在调整产品服务费，请稍等...",
            content: "<div class='text1'><b>调整规则：</b>按照原费率在一级机构费率中的占比进行调整</div>"
              + "<div class='text2'>（如：一级为80%，下级为40%，即下级占一级费率的50%，当一级下调到30%时，系统将自动根据原服务费占比进行下调，即下级调整至15%）</div>"
          })
          this.$http({
            url: "/master/commissonTemplate/addMechan",
            type: 'POST',
            params: this.formData,
          }).then(res => {
            this.$refs.modalLoading.setText({
              title: "完成！",
              progress: 100
            })
            this.$emit("reload");
            this.visible = false;
          })
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
</style>